import React from 'react';
import { Avatar, Typography, Chip } from '@mui/material';
import Card from './UIKit/Card';
import {
  EmojiEvents as EmojiEventsIcon,
  Star,
  Whatshot,
  LocalPolice,
  MilitaryTech,
  WorkspacePremium,
  Looks,
  Code,
  Html,
  Css,
  Book,
  AccessTime,
  Forum,
  Message,
  Group,
  Person,
  Slideshow,
} from '@mui/icons-material';

// Функция для получения цвета по редкости
const getRarityColor = (rarity) => {
  switch (rarity) {
    case 'rare':
      return '#2196f3'; // blue
    case 'epic':
      return '#9c27b0'; // purple
    case 'legendary':
      return '#ff9800'; // orange
    case 'common':
    default:
      return '#8bc34a'; // green
  }
};

// Функция для получения иконки по названию
const getAchievementIcon = (icon) => {
  switch (icon) {
    case 'trophy':
      return <EmojiEventsIcon fontSize="large" />;
    case 'star':
      return <Star fontSize="large" />;
    case 'medal':
      return <Whatshot fontSize="large" />;
    case 'badge':
      return <LocalPolice fontSize="large" />;
    case 'award':
      return <MilitaryTech fontSize="large" />;
    case 'certificate':
      return <WorkspacePremium fontSize="large" />;
    case 'crown':
      return <Looks fontSize="large" />;
    case 'javascript':
      return <Code fontSize="large" />;
    case 'react':
      return <Code fontSize="large" />;
    case 'html':
      return <Html fontSize="large" />;
    case 'presentation':
      return <Slideshow fontSize="large" />;  
    case 'css':
      return <Css fontSize="large" />;
    case 'code':
      return <Code fontSize="large" />;
    case 'book':
      return <Book fontSize="large" />;
    case 'time':
      return <AccessTime fontSize="large" />;
    case 'forum':
      return <Forum fontSize="large" />;
    case 'message':
      return <Message fontSize="large" />;
    case 'group':
      return <Group fontSize="large" />;
    case 'person':
      return <Person fontSize="large" />;
    default:
      return <EmojiEventsIcon fontSize="large" />;
  }
};

// Основной компонент карточки ачивки (вертикальный, центрированный, с gap)
const AchievementCard = ({ achievement }) => {
  return (
    <Card
      sx={{
        height: '100%',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      {/* Иконка ачивки по центру */}
      <Avatar
        sx={{
          bgcolor: getRarityColor(achievement.rarity || 'common'),
          width: 64,
          height: 64,
        }}
      >
        {getAchievementIcon(achievement.icon)}
      </Avatar>
      {/* Название ачивки */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        {achievement.title}
      </Typography>
      {/* Описание ачивки */}
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          textAlign: 'center',
        }}
      >
        {achievement.description}
      </Typography>
      {/* Чип XP по центру */}
      <Chip
        size="small"
        label={`+${achievement.experiencePoints} XP`}
        color="primary"
        sx={{
          fontWeight: 600,
          px: 2,
          fontSize: 16,
        }}
      />
    </Card>
  );
};

export default AchievementCard; 